<template>
    <div class="row">
        <div class="col col-md-6">
            <div class="thumbnail stories large fullwidth">
                <div class="wrap">
                    <div class="image">
                        <a :href="firstItem.url"><img v-lazy="firstItem.thumbnail" :data-srcset="firstItem.thumbnailx2 + ' 2x'" :srcset="firstItem.thumbnailx2 + ' 2x'" :alt="firstItem.name"></a>
                        <div v-if="firstItem.is_sponsor" class="label-box"><span class="label label-sponsored">Sponsored</span></div>
                    </div>
                    <div class="meta">
                        <h3 class="title line2"><a :href="firstItem.url">{{ firstItem.name }}<i v-if="firstItem.is_video" class="ic ic-play-circle-o"></i></a></h3>
                        <div class="category" v-html="firstItem.dbtags"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-md-6">
            <div class="row">
                <div v-for="(val,index) in list" :key="index" :class="val.lastcol + ' ' + val.hidden_device" class="col col-md-6">
                    <div class="thumbnail stories alignment">
                        <div class="wrap">
                            <div class="image">
                                <a :href="val.url"><img v-lazy="val.thumbnail" :data-srcset="val.thumbnailx2 + ' 2x'" :srcset="val.thumbnailx2 + ' 2x'" :alt="val.name"></a>
                            </div>
                            <div class="meta">
                                <h3 class="title line2"><a :href="val.url">{{ val.name }}</a></h3>
                                <div class="category" v-html="val.dbtags"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import config from '@/../myconfig.js'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

const myConfig = config

export default {
  name: 'StoriesHome',
  mounted () {
    this.firstItem = this.list[0]
    this.list.splice(0, 1)
  },
  data: function () {
    return {
      list: window._stories,
      THEME_PATH: myConfig.THEME_PATH,
      firstItem: Object
    }
  }
}
</script>
